











import { Component, Vue } from 'vue-property-decorator';
import axios from 'axios';

@Component
export default class RetailerCalendarStatus extends Vue {
    private link: string = '';
    private target: string = '';
    private titleTemplate: string = '';
    private storeHours: number | null = null;
    private videoHours: number | null = null;
    isLoading: boolean = true;

    constructor() {
        super();
        this.link = this.$attrs['data-link'];
        this.target = this.$attrs['data-target'];

        const encodedTitleTemplate = this.$attrs['data-title-template'];
        this.titleTemplate = encodedTitleTemplate ? decodeURIComponent(escape(atob(encodedTitleTemplate))) : '';
    }

    mounted() {
        this.getAvailability();
    }

    get displayTitle(): string {
        const storeHours = this.storeHours || 0;
        const videoHours = this.videoHours || 0;
        const statusClass = storeHours > 10 && videoHours > 10 ? 'green' : 'red';

        return this.titleTemplate
            .replace('{{ status }}', statusClass)
            .replace('{{ counterTotal }}', (storeHours + videoHours).toString())
            .replace('{{ counterStore }}', storeHours.toString())
            .replace('{{ counterVideo }}', videoHours.toString());
    }

    private getAvailability() {
        const requestContext = (window as any).__litium.requestContext;

        axios({
            method: 'get',
            url: `/api/everyday/meetingavailability`,
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        })
            .then((response: any) => {
                this.storeHours = response.data.storeHours;
                this.videoHours = response.data.videoHours;
                this.isLoading = false;
            })
            .catch((error: any) => {
                console.error('Failed to load meeting availability', error);
                this.isLoading = false;
            });
    }
}
